export const currentSituationSelectOptions = [
  { value: '', name: 'Select an option' },
  { value: 'graduated_college_working', name: 'Graduated College: currently working' },
  { value: 'graduated_college_seeking_job', name: 'Graduated College: looking for a job' },
  { value: 'college_classes_full_time', name: 'Currently Taking College Classes - Full Time' },
  { value: 'college_classes_part_time', name: 'Currently Taking College Classes - Part Time' },
  { value: 'college_no_classes', name: 'In College - Not currently taking college classes' },
  { value: 'working_full_time', name: 'Working Full Time' },
  { value: 'working_part_time', name: 'Working Part Time' },
  { value: 'not_working_or_studying', name: 'Not in school, not working' },
  { value: 'completed_high_school', name: 'Just completed high school - Not in College' },
  { value: 'other', name: 'Other' },
];

export const sourceOfDiscoverySelectOptions = [
  { value: '', name: 'Select an option' },
  { value: 'instagram', name: 'Instagram' },
  { value: 'youtube', name: 'YouTube' },
  { value: 'social_media_other', name: 'Social media - Other' },
  { value: 'friend_or_family', name: 'Friend or Family' },
  { value: 'college_campus_recruiting', name: 'College Campus Recruiting' },
  { value: 'website', name: 'Aptive Website' },
  { value: 'grassroot_recruiting', name: 'Grassroots Recruiting (Door-to-door)' },
  { value: 'other', name: 'Other' },
];

export const lastIndustrySelectOptions = [
  { value: '', name: 'Select an option' },
  { value: 'pest', name: 'Pest Control' },
  { value: 'alarms', name: 'Alarms' },
  { value: 'solar', name: 'Solar' },
  { value: 'roofing', name: 'Roofing' },
  { value: 'other', name: 'Other' },
];

export const w9StatusList = [
  { value: 'started', name: 'Started' },
  { value: 'signed', name: 'Signed - Pending Approval' },
  { value: 'voided_by_rep', name: 'Voided by Rep' },
  { value: 'declined_by_admin', name: 'Declined by Admin' },
  { value: 'approved', name: 'Approved by Admin' },
];
